import { useMemo } from 'react';

import { capitalizeFirstCharLowerOthers } from '@utils/formatting-utils';

import { useGetAmendmentMedicalInsuredsLovs } from '../amendment.slice';

export interface AmendmentMedicalInsuredsLovs {
  relation: Record<string, string>;
  continuity: Record<string, string>;
  grApplicable: Record<string, string>;
}

interface EnumValue {
  name: string;
}

export function useAmendmentMedicalInsuredsLovs(
  isMedicalLine: boolean
): AmendmentMedicalInsuredsLovs {
  const { data } = useGetAmendmentMedicalInsuredsLovs({ skip: !isMedicalLine });

  return useMemo(() => {
    const continuityRaw: EnumValue[] = data?.ContinuityList?.enumValues ?? [];
    const relationRaw: EnumValue[] = data?.RelationsList?.enumValues ?? [];

    const continuity: Record<string, string> = continuityRaw
      .map((g: EnumValue) => g?.name)
      .filter((s): s is string => Boolean(s))
      .reduce(
        (acc: Record<string, string>, curr: string) => {
          acc[curr] = capitalizeFirstCharLowerOthers(curr);

          return acc;
        },
        {} as Record<string, string>
      );

    const relation: Record<string, string> = relationRaw
      .map((g: EnumValue) => g?.name)
      .filter((s): s is string => Boolean(s))
      .reduce(
        (acc: Record<string, string>, curr: string) => {
          acc[curr] = capitalizeFirstCharLowerOthers(curr);

          return acc;
        },
        {} as Record<string, string>
      );

    return { relation, continuity, grApplicable: { YES: 'Yes', NO: 'No' } };
  }, [data]);
}
